import { render, staticRenderFns } from "./updateChannel.vue?vue&type=template&id=2ebba526"
import script from "./updateChannel.vue?vue&type=script&lang=js"
export * from "./updateChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports